import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '../../pipes/translate.module';
import { AnswerLegendComponent } from './answer-legend.component';

@NgModule({
  declarations: [AnswerLegendComponent],
  imports: [CommonModule, TranslateModule],
  exports: [AnswerLegendComponent]
})
export class AnswerLegendModule { }
